module.exports = __webpack_public_path__ + "../resources/img/ic_user_manual.47e04f1c.svg";